import PurchaseDetails from './PurchaseDetails';

export default PurchaseDetails;
